import { LandingSectionEyebrow } from '@/components/landing/landing-section-eyebrow'
import { Button } from '@/components/ui/button'
import { LANDING_SECTION_GRADIENT } from '@/lib/landing-content'
import { Link } from 'react-router-dom'

export function LandingMissionCtaSection() {
  return (
    <section
      id="pricing"
      className="py-12 md:py-32 scroll-fade-up"
      style={{ backgroundImage: LANDING_SECTION_GRADIENT }}
    >
      <div className="container mx-auto px-4 md:px-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col gap-6 md:gap-16 items-start">
            <LandingSectionEyebrow label="PRICING" />
            <div className="flex flex-col gap-4 md:gap-8 items-start">
              <h2 className="text-3xl md:text-[48px] font-display text-gray-900 leading-[1.2] tracking-[-0.96px] max-w-5xl">
                Our mission: to provide every departure with a dignified next step{' '}
                <span className="font-display text-brand-light">
                  at a fraction of the cost of traditional outplacement.
                </span>
              </h2>
              <Button
                asChild
                className="bg-pelgo-blue-light hover:bg-pelgo-blue-light/90 text-white rounded-full px-6 py-3 text-base font-semibold min-h-[48px]"
              >
                <Link to="/contact">Request Free Trial</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
